import axios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios'
import qs from 'querystring'
import _Vue from 'vue'
import store from '@/store'

// 接口前缀
const hostname = window.location.hostname
let country = ''
// if (!hostname.includes('-')) {
//   country = ''
// } else {
//   country = 'intl'
// }
switch (hostname.split('-') ? hostname.split('-')[0] : '') {
  // 越南
  case 'vn':
    country = 'vn'
    break
  // 菲律宾
  case 'ph2':
    country = 'ph'
    break
  case 'ph':
    country = 'ph'
    break
  // 印度
  case 'in':
    country = 'in'
    break
  // 泰国
  case 'th':
    country = 'th'
    break
  // 马来
  case 'my':
    country = 'my'
    break
  // 墨西哥
  case 'mex':
    country = 'mex'
    break
  case 'sg':
    country = 'intl'
    break
  // 印尼无前缀
  default:
    break
}
const instance = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_API}/${country}`,
  timeout: 120000,
  paramsSerializer: params => {
    return qs.stringify(params)
  },
})
const requestInterceptor = (config: AxiosRequestConfig) => {
  config.headers['X-ADVAI-TOKEN'] = store.bizToken
  const localeMap: { [key: string]: string } = {
    'zh': 'zh-CN',
    'id': 'id-ID',
    'en': 'en-US',
  }
  const acceptLang = localeMap[store.locale] ?? 'en-US'
  config.headers['Accept-Language'] = acceptLang
  return config
}

const responseInterceptor = (response: AxiosResponse) => {
  return response
}

instance.interceptors.request.use(requestInterceptor)
instance.interceptors.response.use(responseInterceptor)

declare module 'vue/types/vue' {
  // tslint:disable-next-line:interface-name
  interface Vue {
    $http: AxiosInstance
  }
  // tslint:disable-next-line:interface-name
  interface VueConstructor<V extends Vue> {
    http: AxiosInstance
  }
}

export default {
  install(Vue: typeof _Vue, options?: any) {
    Vue.http = instance
    Vue.prototype.$http = instance
  },
}

export { instance as axios }
